import { DriverGender } from 'scenes/motor/flows/addDriver/types';

import { PolicyHolder } from './types';

export const defaultPolicyHolder: PolicyHolder = {
  firstName: '',
  lastName: '',
  gender: DriverGender.Unspecified,
  dob: '',
  isSelected: false,
};
